import { render, staticRenderFns } from "./CreateProductionZone.vue?vue&type=template&id=12dfc65f&scoped=true&"
import script from "./CreateProductionZone.vue?vue&type=script&lang=js&"
export * from "./CreateProductionZone.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductionZone.vue?vue&type=style&index=0&id=12dfc65f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dfc65f",
  null
  
)

export default component.exports